import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Table, TableModule } from "primeng/table";
import { OrderNotes } from "../../../core/models/invoice-preview/orderNotes";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { InvoicePreviewSummaryService } from "../../../core/services/invoice-preview-summary.service";
import { LoaderService } from "../../../core/services/loader.service";
import { exportExcel } from "../../../core/services/shared.service";
import { SelectModule } from "primeng/select";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HidedynamicsdatePipe } from "../../../shared/pipes/hidedate/hidedynamicsdate.pipe";

@UntilDestroy()
@Component({
  selector: "jni-invoice-preview-billing-notes-listing",
  templateUrl: "./invoice-preview-billing-notes-listing.component.html",
  styleUrls: ["./invoice-preview-billing-notes-listing.component.scss"],
  imports: [
    TableModule,
    SelectModule,
    CommonModule,
    FormsModule,
    HidedynamicsdatePipe,
  ],
})
export class InvoicePreviewBillingNotesListingComponent implements OnInit {
  @Input() saleOrderId = "";
  @Output() selectedOrderNotesListing = new EventEmitter<OrderNotes[]>();
  @Output() scrollHiddenStatus = new EventEmitter();
  @Input() orderNotesGridListing: OrderNotes[] = [];

  @ViewChild("dt") table!: Table;

  purchaseOrderNumber: string[] = [];
  selectedOrderNotesGridListing: OrderNotes[] = [];
  orderNotesModalStatus = false;
  typeList = [
    {
      id: 1,
      name: "Billing note",
    },
    {
      id: 2,
      name: "Collections",
    },
    // 11286 - PGL-270 Remove Invoice Note option From All Note Forms
    // {
    //   id: 3,
    //   name: 'Invoice note'
    // },
    {
      id: 4,
      name: "Order note",
    },
  ];

  constructor(
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private router: ActivatedRoute,
    private _invoicePreviewSummaryService: InvoicePreviewSummaryService
  ) {
    this.router.params.subscribe(params => {
      this.saleOrderId = params["id"];
    });
  }

  ngOnInit(): void {
    if (this.saleOrderId) {
      this.getSalesOrderNotes(this.saleOrderId);
    }
  }

  getSalesOrderNotes(saleOrderId: string) {
    if (saleOrderId) {
      this._loaderService.setLoaderState(true);
      this._invoicePreviewSummaryService
        .getSalesOrderNotes(saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              const billingNotes = res.data.filter(x =>
                x?.type?.toLowerCase()?.includes("billing")
              );
              this.orderNotesGridListing = billingNotes;
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Order note not found");
          },
        });
    }
  }

  exportExcel() {
    exportExcel(this.orderNotesGridListing, "Billing Orders");
  }
}
